import styled from 'styled-components';

import {
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;

export const Link = styled.a``;

export const Container = styled.div`
    overflow: auto;
`;

export const CenteredMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InlineTextContainer = styled.span`
  display: inline-flex;
  align-items: center;
`;

export const DeletedLabel = styled(Text)`
  color: #DC651E;
  margin-left: 0.5em;
`;
